import Store from '@/store';

export function undoWarn() {
  Store.commit('undoWarn');
}

export function setWarn(message: string) {
  Store.commit('onWarn', message);
}
